<template>
  <div class="mt-4">
    <div class="footer">
      <ul class="footermenu mb-0">
        <!-- <li><a href="/about">About Us</a></li>
        <li><a href="/contact">Contact Us</a></li>-->
        <li>
          <a href="#" @click.prevent="setContent(0)">Privacy Policy</a>
        </li>
        <li>
          <a href="#" @click.prevent="setContent(1)">Delivery Policy</a>
        </li>
        <li>
          <a href="#" @click.prevent="setContent(2)">Terms And Conditions</a>
        </li>
        <li>
          <a href="#" @click.prevent="setContent(3)">Refund Policy</a>
        </li>
      </ul>
    </div>
    <modal v-if="showModal" full-header @close="closeModal">
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">{{ partTitle }}</h2>
          </div>
          <p class="py-4">{{ partContent }}</p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index:2">
          <button class="privacy-btn pull-right" data-dismiss="modal">OK</button>
        </div>
        <div class="privacy-footer"/>
      </template>
    </modal>
  </div>
</template>

<script>
import modal from "./../modal";
import { getStore } from "../../api/services/storeService.js";
import { logger } from "./../../api/Logger.js";
export default {
  name: "PageFooter",
  components: {
    modal
  },
  data() {
    return {
      store: Object,
      partContent: "",
      partTitle: "",
      showModal: false
    };
  },
  created() {
    let that = this;
    getStore(this.$route.params.storeid)
      .get()
      .then(function(doc) {
        if (doc.exists) {
          that.store = doc.data();
        }
      })
      .catch(reason => {
        logger.log(
          reason.name,
          reason.toString(),
          that.$router.currentRoute.fullPath,
          logger.LogType.Error
        );
        that.$router.replace("/GeneralError");
      });
  },
  methods: {
    setContent(part) {
      this.showModal = true;
      if (this.store.Policies) {
        switch (part) {
          case 0:
            this.partContent = this.store.Policies["PolicyTypePrivacy"];
            this.partTitle = "Privacy Policy";
            break;
          case 1:
            this.partContent = this.store.Policies["PolicyTypeDelivery"];
            this.partTitle = "Delivery Policy";
            break;
          case 2:
            this.partContent = this.store.TermsAndConditions;
            this.partTitle = "Terms And Conditions";
            break;
          case 3:
            this.partContent = this.store.Policies["PolicyTypeRefund"];
            this.partTitle = "Refund Policy";
            break;
        }
      }
    },
    closeModal() {
      this.showModal = false;
    }
  }
};
</script>
